/* global Swiper, windowWidth, breakpointMd */
// *******************************************************************************
// 1.0 - Hero Slider
// *******************************************************************************

window.addEventListener('spectoCmsContentLoaded', () => {
  window.testimonialSliderElements = document.querySelectorAll('[data-slider="testimonials-slider"]');

  window.testimonialSliderOptions = {
    spaceBetween: 20,
    speed: 800,
    watchOverflow: true,
    breakpoints: {
      1200: {
        spaceBetween: 48,
      },
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  };

  testimonialSliderElements.forEach((el) => {
    const slides = parseInt(el.getAttribute('data-slides'), 10);
    const parent = el.closest('.testimonials');
    const arrowRight = parent.querySelector('.swiper-button-next');
    const arrowLeft = parent.querySelector('.swiper-button-prev');

    testimonialSliderOptions.navigation.nextEl = arrowRight;
    testimonialSliderOptions.navigation.prevEl = arrowLeft;

    if (injection.windowWidth() < injection.breakpointMd) {
      testimonialSliderOptions.slidesPerView = 1;
    } else {
      testimonialSliderOptions.slidesPerView = slides;
    }

    // eslint-disable-next-line no-new
    new Swiper(el, testimonialSliderOptions);
  });
});
